import { forwardRef } from "react";

import { BaseInput } from "./BaseInput";
import type { BaseInputProps } from "./foundations/inputTypes";

export interface TextInputProps extends Omit<BaseInputProps, "type"> {
  type?: "text" | "password" | "search" | "email";
  /** Normalize each input value before `onChange`. */
  sanitize?: (value: string) => string;
}

/**
 * Single-line text input.
 * 라벨이 필요하면 `<Field>`로 감싸세요 — 자체 `label` prop은 없습니다.
 */
export const TextInput = forwardRef<HTMLInputElement, TextInputProps>(
  ({ type = "text", sanitize, onChange, ...props }, ref) => {
    return (
      <BaseInput
        ref={ref}
        fieldControlName="TextInput"
        type={type}
        onChange={(event) => {
          if (sanitize) {
            const sanitized = sanitize(event.target.value);
            if (sanitized !== event.target.value) {
              event.target.value = sanitized;
            }
          }
          onChange?.(event);
        }}
        {...props}
      />
    );
  },
);

TextInput.displayName = "TextInput";
